import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faCircleXmark, faTriangleExclamation, faCircleInfo, faXmark } from '@fortawesome/free-solid-svg-icons';
import toast from 'react-hot-toast';
import './CustomToast.css';

type ToastType = 'success' | 'error' | 'warning' | 'info';

interface CustomToastProps {
    title: string;
    message: string;
    type: ToastType;
    id?: string;
}

// Карта иконок для каждого типа
const iconMap: Record<ToastType, any> = {
    success: faCircleCheck,
    error: faCircleXmark,
    warning: faTriangleExclamation,
    info: faCircleInfo,
};

const CustomToast: React.FC<CustomToastProps> = ({ title, message, type, id }) => {
    const handleClose = () => {
        toast.dismiss(id);
    };

    return (
        <div className={`custom-toast custom-toast--${type}`} role="alert" aria-live="polite">
            {/* Иконка */}
            <div className="custom-toast__icon-wrapper">
                <FontAwesomeIcon icon={iconMap[type]} className="custom-toast__icon" />
            </div>

            {/* Контент */}
            <div className="custom-toast__content">
                <div className="custom-toast__header">{title}</div>
                <div className="custom-toast__body">{message}</div>
            </div>

            {/* Кнопка закрытия */}
            <button
                className="custom-toast__close"
                onClick={handleClose}
                aria-label="Закрыть уведомление"
            >
                <FontAwesomeIcon icon={faXmark} />
            </button>
        </div>
    );
};

// Factory функция для создания toast
export const createCustomToast = (
    title: string,
    message: string,
    type: ToastType
): string => {
    return toast.custom(
        (t) => <CustomToast title={title} message={message} type={type} id={t.id} />,
        { duration: 4000 }
    );
};

export default CustomToast;
